import { useObservableState } from 'observable-hooks';
import { CodeframesModalBLoC as BLoC, useCodeframesModalBLoC } from './CodeframesModal.bloc';
import { CodeframesModalTypes } from './CodeframesModal.types';
import { PDialogV2 } from 'components/prime/PDialogV2/PDialogV2';
import { HStack, VStack } from 'components/layouts/primitives/Stack/Stack';
import { PButton } from 'components/prime/PButton/PButton';
import { Notification } from 'components/Notification/Notification';
import { CodeframesModalName } from './components/CodeframesModalName/CodeframesModalName';
import { CodeframesModalType } from './components/CodeframesModalType/CodeframesModalType';
import { CodeframesModalFile } from './components/CodeframesModalFile/CodeframesModalFile';
import { CodeframesModalCustomer } from './components/CodeframesModalCustomer/CodeframesModalCustomer';
import { Text } from 'components/Text/Text';
import { LinkText } from 'components/LinkText/LinkText';

const CodeframesModalInner: React.FC = () => {
  const { isEditCodeframe, isAdmin, $loading, createCodeFrame, editCodeFrame, closeModal } =
    useCodeframesModalBLoC();
  const loading = useObservableState($loading);

  return (
    <PDialogV2
      visible
      title={isEditCodeframe ? 'Edit codeframe' : 'Create new codeframe'}
      onHide={closeModal}
      footer={
        <HStack gap="gap2">
          <PButton
            className="w-full"
            label="Cancel"
            severity="secondary"
            onClick={closeModal}
            disabled={loading !== 'loaded'}
          />
          <PButton
            className="w-full"
            label={isEditCodeframe ? 'Confirm edit' : 'Create'}
            onClick={isEditCodeframe ? editCodeFrame : createCodeFrame}
            loading={loading !== 'loaded'}
          />
        </HStack>
      }
    >
      <VStack gap="gap5">
        <Text color="neutral500">
          Upload a file that best describes how your data is themed. Not sure where to start?
          <LinkText
            as="a"
            href={
              isAdmin
                ? `${window.location.origin}/admin/tc/codeframes/template`
                : `${window.location.origin}/tc/codeframes/template`
            }
          >
            {` `}
            Download template
          </LinkText>
        </Text>
        {isAdmin && <CodeframesModalCustomer />}
        <CodeframesModalName />
        <CodeframesModalType />
        <CodeframesModalFile />
        {isEditCodeframe && (
          <Notification
            severity="warning"
            description="Uploading a new codeframe file will replace your current codeframe. It will not affect any Explores themed using previous codeframe."
            layoutType="compact"
          />
        )}
      </VStack>
    </PDialogV2>
  );
};

export const CodeframesModal: React.FC<CodeframesModalTypes.CodeframesModalProps> = (props) => {
  return (
    <BLoC {...props}>
      <CodeframesModalInner />
    </BLoC>
  );
};
